import {
	SafeAreaView,
	StyleSheet,
	Text,
	TouchableOpacity,
	View,
} from "react-native";
import React from "react";
import PictureCard from "../../components/PictureCard";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { formatCPF } from "../../utils/CPFFunctions";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { clearSavedUser } from "../../store/slices/authSlice";
import { SettingsScreenProps } from "./HomeStack";
import { useTheme } from "react-native-paper";

const Settings = ({ navigation }: SettingsScreenProps) => {
	const { colors } = useTheme();
	const user = useAppSelector(s => s.auth.subUser!);
	const dispatch = useAppDispatch();
	const getOut = () => {
		clearSavedUser(dispatch)();
	};

	const deleteAccount = () => navigation.navigate("SignIn", { delete: true });
	const openWebsite = () => navigation.navigate("SignIn", { delete: false });
	const goToTos = () => navigation.navigate("ToS");

	return (
		<SafeAreaView>
			<View style={styles.profileContainer}>
				<PictureCard />
				<Text style={styles.greeting}>
					Olá,
					<Text style={{ fontWeight: "bold" }}> {user.name.split(" ")[0]}</Text>
				</Text>
				<Text style={styles.cpf}>
					{user.cpf
						? `CPF: ${formatCPF(user.cpf)}`
						: `Matrícula: ${user.institution_id}`}
				</Text>
			</View>
			<TouchableOpacity style={styles.btn} onPress={goToTos}>
				<MaterialCommunityIcons
					name="file-document-multiple-outline"
					size={24}
					color="#8ea3a4"
					style={styles.exitIcon}
				/>
				<Text style={styles.logoutLabel}>Termos de uso</Text>
			</TouchableOpacity>
			<TouchableOpacity style={styles.btn} onPress={openWebsite}>
				<MaterialCommunityIcons
					name="shield-account-variant"
					size={24}
					color="#8ea3a4"
					style={styles.exitIcon}
				/>
				<Text style={styles.logoutLabel}>Política de Privacidade</Text>
			</TouchableOpacity>
			<TouchableOpacity style={styles.btn} onPress={getOut}>
				<MaterialCommunityIcons
					name="logout"
					size={24}
					color="#8ea3a4"
					style={styles.exitIcon}
				/>
				<Text style={styles.logoutLabel}>Sair</Text>
			</TouchableOpacity>
			<TouchableOpacity style={[styles.btn]} onPress={deleteAccount}>
				<MaterialCommunityIcons
					name="delete"
					size={24}
					color={colors.danger}
					style={styles.exitIcon}
				/>
				<Text style={[styles.logoutLabel, { color: colors.danger }]}>
					Deletar conta
				</Text>
			</TouchableOpacity>
		</SafeAreaView>
	);
};

export default Settings;

const styles = StyleSheet.create({
	profileContainer: {
		width: "90%",
		marginHorizontal: "5%",
		marginTop: 10,
		marginBottom: 37,
		paddingTop: 10,
		backgroundColor: "#fff",
		borderRadius: 18,
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.32,
		shadowRadius: 5.46,
		elevation: 9,
		alignItems: "center",
	},
	greeting: {
		marginTop: 16,
		fontSize: 18,
	},
	cpf: {
		color: "#858585",
		fontSize: 16,
		marginBottom: 8,
	},
	btn: {
		width: "90%",
		marginHorizontal: "5%",
		borderWidth: 2,
		borderRadius: 17,
		borderColor: "#e1e8e8",
		padding: 19,
		alignItems: "center",
		flexDirection: "row",
		marginBottom: 10,
	},
	delete: {
		width: "90%",
		marginHorizontal: "5%",
		borderWidth: 2,
		borderRadius: 17,
		borderColor: "#e1e8e8",
		padding: 19,
		alignItems: "center",
		flexDirection: "row",
	},
	exitIcon: {
		marginRight: 13,
	},
	logoutLabel: { color: "#8ea3a4", fontWeight: "500", fontSize: 16 },
});
